import { Injectable, TemplateRef } from '@angular/core';
import { AccordionIconType, ForceAny } from '@shared/types';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  static TABLE_FILTER_QUERY = '?page=1&perPage=100';
  static TABLE_DYNAMIC_FILTER_QUERY = {
    dynamicQuery: {},
    paginationQuery: { page: 1, perPage: 100 },
  };
  private buttonLoadingSource = new BehaviorSubject<boolean>(false);
  buttonLoading$ = this.buttonLoadingSource.asObservable();

  accordionClickListener = new Subject<AccordionIconType>();
  tableClickListener = new Subject<boolean>();
  languageChange$ = new BehaviorSubject<string>('');

  isAsyncAccordionClick = false;
  clientId!: string;

  asyncApiStatus = new Subject<boolean>();

  templateMap!: { [key: string]: TemplateRef<ForceAny> };

  setButtonLoading(isLoading: boolean) {
    this.buttonLoadingSource.next(isLoading);
  }
}
